export const BUILD_ID = process.env.REACT_APP_BUILD_ID || process.env.REACT_APP_VERSION || '3.0.0-dev';
export const APP_VERSION = process.env.REACT_APP_VERSION || '3.0.0';
export const API_ROOT = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
export function compareVersions(a = '0', b = '0') {
  const left = String(a).split(/[.+-]/).map((part) => Number.parseInt(part, 10) || 0);
  const right = String(b).split(/[.+-]/).map((part) => Number.parseInt(part, 10) || 0);
  for (let i = 0; i < Math.max(left.length, right.length); i += 1) { const delta = (left[i] || 0) - (right[i] || 0); if (delta) return Math.sign(delta); }
  return 0;
}
export function compatibilityFor(info, current = APP_VERSION) {
  if (!info) return { required: false, available: false, maintenance: false };
  return { required: Boolean(info.forceUpdate) || compareVersions(current, info.minimumFrontendVersion) < 0, available: compareVersions(current, info.latestFrontendVersion) < 0, maintenance: Boolean(info.maintenanceMode) };
}
